<template>
    <BasicHeader pretitle="aqfer Marketing Data Platform" title="File Browser" />
    <div class="container-fluid fb-shell" :class="$store.state.darkMode ? 'dark' : 'light'">
        <div class="fb-panel">
            <div class="fb-panel-body">
                <FileBrowserControls :initialNamespace="$route.query.namespace || ''"
                    :initialCredential="$route.query.credential || ''" :initialBucket="$route.params.bucket || ''"
                    :autoSelectBucket="true" @credentialChange="onCredentialChange" @bucketChange="onSelectBucket"
                    @refresh="onRefresh" />
            </div>
        </div>
        <router-view v-if="credential" />
        <div v-else class="fb-panel">
            <div class="fb-empty">
                <div class="fb-empty-icon"><i class="fa-solid fa-folder-open"></i></div>
                <h2 class="fb-empty-title">Nothing selected yet</h2>
                <p class="fb-empty-subtitle">
                    Pick a credential above to list the buckets it can reach, then choose one to browse its objects.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
/*
 * File browser page. Buckets, objects and download URLs all come from pail
 * (`/v2/cids/:cid/filebrowser/:credential/buckets`); the namespace and credential are
 * carried in the query string so a reload or a shared link reopens the same selection.
 */
import BasicHeader from "../../components/BasicHeader.vue";
import FileBrowserControls from "../../components/filebrowser/FileBrowserControls.vue";

export default {
    components: { BasicHeader, FileBrowserControls },
    name: "FileBrowser",
    data() {
        return {
            credential: null,
            namespace: null,
            unmountRoute: null,
        };
    },
    methods: {
        onCredentialChange({ name, namespace }) {
            this.credential = name;
            this.namespace = namespace;
        },
        routeQuery() {
            return {
                ...(this.namespace ? { namespace: this.namespace } : {}),
                ...(this.credential ? { credential: this.credential } : {}),
            };
        },
        onSelectBucket(bucket) {
            const route = {
                name: "File Browser List",
                params: {
                    bucket: `${bucket}`,
                    cid: this.$store.state.currentClient.cid,
                },
                query: this.routeQuery(),
            };
            // the bucket is the first crumb - every folder below it is appended
            this.$store.dispatch("setBreadcrumbs", [{ name: bucket, route }]);
            // a different bucket means a different root, so the folder path restarts
            this.$store.dispatch("amdp/setFolderPath", "");
            // to avoid pushing a route after the page has been left
            if (this.unmountRoute) return;
            this.$router.push(route);
        },
        onRefresh() {
            const breadcrumbs = this.$store.state.breadcrumbs;
            if (!breadcrumbs.length) return;
            let path = { ...breadcrumbs[breadcrumbs.length - 1].route };
            // crumbs recorded by Datatable carry no query - keep the credential in the URL
            path.query = { ...this.$route.query, ...this.routeQuery(), refresh: Date.now() };
            this.$router.push(path);
        },
    },
    unmounted() {
        this.unmountRoute = true;
    },
};
</script>

<style>
@import "../../components/filebrowser/fileBrowser.css";
</style>

<style scoped>
.fb-panel-body {
    padding: 1.25rem;
}
</style>
